import STORE from '../../store';

const getTimelineEventsSnapshot = ({ accountId }: { accountId: string }) => {
  return STORE.getTimelineEventsRef({ accountId });
};

export default getTimelineEventsSnapshot;
